// Back button rendered only inside the CPL app's WebView - identified by user agent
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faArrowLeft } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation, useNavigate } from "react-router-dom";
import { isEmbeddedApp } from "utils/embeddedApp";

const DEFAULT_BACK_TO = "/dashboard";

type AppBackButtonProps = {
  backTo?: string;
  "data-test-id"?: string;
};

const AppBackButton = ({ backTo = DEFAULT_BACK_TO, "data-test-id": testId }: AppBackButtonProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  if (!isEmbeddedApp()) {
    return null;
  }

  const canGoBack = location.key !== "default";
  const goBack = () => (canGoBack ? navigate(-1) : navigate(backTo, { replace: true }));

  return (
    <button
      type="button"
      data-test-id={testId}
      className="cpl-btn cpl-btn-link text-decoration-none d-flex align-items-center mb-3 mt-3"
      onClick={goBack}
    >
      <FontAwesomeIcon icon={faArrowLeft as IconProp} />
      <span className="ms-2">Go back</span>
    </button>
  );
};

export default AppBackButton;
